<template>
  <el-dialog
    v-loading="loading"
    class="editBill"
    title="修改发票信息"
    :visible.sync="editVisible"
    width="862px"
    :before-close="handleClose"
  >
    <el-dropdown trigger="click">
      <div class="info-box" style="padding-right:110px;">
        <span style="width:220px;" class="addressInfo">
          {{ departInfo.FBuyDepartName }}
        </span>
        <span class="addAddress">更多部门</span>
        <svg-icon icon-class="select" />
      </div>
      <el-dropdown-menu v-if="BuyDepartList.length" slot="dropdown" class="departSelect">
        <el-dropdown-item
          v-for="(item, index) in BuyDepartList"
          :key="index"
          class="departList"
          @click.native="departChange(item, index)"
        >
          <div>
            <div class="name">
              <span :style="item.FDepartID == departInfo.FBuyDepartID ? 'color:#EC212D;' : ''">{{ item.FDepartName }}</span>
            </div>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div class="departInfo">
      <div class="topArrow" />
      <div class="content">
        <p>
          <span class="title">发票抬头</span>：{{ departInfo.FInvoiceUnitName }}
        </p>
        <p>
          <span class="title">开户银行</span>：{{ departInfo.FBank }}
        </p>
        <p>
          <span class="title">税号</span>：{{ departInfo.FTaxNo }}
        </p>
        <p>
          <span class="title">银行账户</span>：{{ departInfo.FAccountNo }}
        </p>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="medium" @click="handleClose">取 消</el-button>
      <el-button size="medium" type="primary" @click="confirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '@/utils/request.js'
export default {
  filters: {

  },
  props: {
    editVisible: {
      type: Boolean
    },
    invoiceUnit: {
      type: Object,
      default: () => {}
    },
    orderId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      departInfo: {
        FAccountNo: '',
        FBank: '',
        FDepartID: '',
        FERPUnitID: '',
        FInvoiceUnitName: '',
        FTaxNo: '',
        FBuyDepartID: '',
        FBuyDepartName: ''
      },
      BuyDepartList: []
    }
  },
  watch: {
    editVisible(val) {
      if (val) {
        for (const key in this.invoiceUnit) {
          this.departInfo[key] = this.invoiceUnit[key]
        }
      }
    }
  },
  created() {
    this.getDistributionUnit()
  },
  methods: {
    confirm() {
      if (this.departInfo.FBuyDepartID == this.invoiceUnit.FBuyDepartID) return this.handleClose()
      this.loading = true
      const data = new URLSearchParams()
      data.append('fOrderID', this.orderId)
      data.append('fDepartID', this.departInfo.FBuyDepartID)
      data.append('fERPUnitID', this.departInfo.FERPUnitID)
      request({
        url: '/mall/mallmanage/demandOrder/updateBuyDepartAndUnit',
        method: 'post',
        data
      })
        .then(res => {
          if (res.result) {
            this.$message.success(res.msg)
            this.$emit('cfmEdit', this.departInfo)
          } else {
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    departChange(t) {
      this.departInfo.FBuyDepartID = t.FDepartID
      this.departInfo.FBuyDepartName = t.FDepartName
      this.departInfo.FERPUnitID = t.FERPUnitID
      request({
        url: '/mall/mallmanage/demandOrder/getInvoiceUnit?fERPUnitID=' + this.departInfo.FERPUnitID,
        method: 'post'
      })
        .then(res => {
          if (res.result) {
            for (const key in res.data) {
              this.departInfo[key] = res.data[key]
            }
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    getDistributionUnit() {
      request({
        url: '/mall/mallmanage/demandOrder/distributionUnit',
        method: 'post'
      })
        .then(res => {
          this.BuyDepartList = res.data || []
        })
    },
    handleClose() {
      this.$emit('closeEdit', false)
    }
  }
}
</script>

<style lang='scss'>
    .departSelect {
        max-height: 350px;
        overflow-y: auto;
        z-index: 999;
        position: absolute;
        top: 64px;
        border: 1px solid #d2d2d2;
        width: 352px;
    }
    .editBill {
        .el-dialog {
            border-radius: 6px;

            .el-dialog__header {
                height: 66px;
                position: relative;
                width: 765px;
                margin: auto;
                background-color: #fff;
                border-radius: 6px 6px 0 0;

                .el-dialog__title {
                    height: 26px;
                    line-height: 26px;
                    position: absolute;
                    bottom: 0;
                    font-size: 20px;
                    color: #333;
                    font-weight: bold;
                }

                .el-dialog__headerbtn {
                    top: 24px;
                    right: 0px;
                }

                .el-icon-close {
                    color: #C0C5CF;
                }
            }

            .el-dialog__body {
                padding: 30px 48px;
                .info-box {
                    display: inline-block;
                    cursor: pointer;
                    position: relative;
                    max-width: 946px;
                    height: 40px;
                    line-height: 40px;
                    padding-left: 20px;
                    border: 1px solid #EC212D;
                    border-radius: 4px;
                    font-size: 14px;
                    color: #333;

                    .addressInfo {
                        display: inline-block;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .default {
                        display: inline-block;
                        position: absolute;
                        right: 105px;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 43px;
                        height: 18px;
                        line-height: 18px;
                        font-size: 12px;
                        text-align: center;
                        background: #EC212D;
                        color: #fff;
                        border-radius: 2px;
                    }

                    .addAddress {
                        position: absolute;
                        right: 28px;
                        color: #EC212D;
                    }

                    .svg-icon {
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        font-size: 20px;
                    }
                }
                .departInfo {
                    position: relative;
                    width: 100%;
                    height: 96px;
                    background: #F1F1F1;
                    margin-top: 18px;
                    padding: 0 20px;
                    color: #333333;
                    font-size: 14px;

                    .content {
                        display: flex;
                        flex-wrap: wrap;
                    }

                    p {
                        width: 354px;
                        line-height: 48px;
                    }

                    .topArrow {
                        position: absolute;
                        top: -20px;
                        left: 50px;
                        width: 0;
                        height: 0;
                        border: 10px solid transparent;
                        border-bottom-color: #F1F1F1;
                    }

                    .title {
                        display: inline-block;
                        width: 70px;
                        text-align: justify;
                        text-justify: distribute-all-lines;
                        text-align-last: justify;
                        color: #777777;
                    }
                }
            }

            .el-dialog__footer {
                padding: 10px 20px;
                text-align: center;
                border-top: 1px solid #E8E8E8;
                .el-button {
                    width: 72px;
                }
            }
        }
    }
</style>
